export const FOCUS_TAB_KEY = 'PDP_FOCUS_TAB';

export const ActiveTabSearchKey = 'tab';
export const FocusTabHashKey = 'focus_tab';

/** 사이즈 탭 툴팁 노출 여부 localStorage 키 */
export const SIZE_TAB_TOOLTIP_KEY = 'isSizeTabTooltipShown';

/** 탭 레드닷 노출 여부 localStorage 키 prefix */
export const TAB_DOT_KEY_PREFIX = 'pdp_tab_dot_';

/** 탭 타입별 레드닷 localStorage 키 생성 */
export const getTabDotKey = (tabType: string) => `${TAB_DOT_KEY_PREFIX}${tabType}`;

/** 서버 탭 타입을 클라이언트 TabType으로 매핑 */
export const SERVER_TAB_TYPE_MAP: Record<string, number> = {
  DETAIL: 0, // TabType.PRODUCT_DETAIL_INFO
  SIZE: 1, // TabType.SIZE_INFO
  REVIEW: 2, // TabType.REVIEW
  PRODUCT_RECOMMEND: 3, // TabType.RECOMMEND
  CONTACT: 4, // TabType.CONTACT
  INGREDIENT: 5, // TabType.BEAUTY_INGREDIENT
};

/** 클라이언트 TabType을 서버 탭 타입으로 역매핑 */
export const CLIENT_TO_SERVER_TAB_TYPE_MAP: Record<number, string> = {
  0: 'DETAIL', // TabType.PRODUCT_DETAIL_INFO
  1: 'SIZE', // TabType.SIZE_INFO
  2: 'REVIEW', // TabType.REVIEW
  3: 'PRODUCT_RECOMMEND', // TabType.RECOMMEND
  4: 'CONTACT', // TabType.CONTACT
  5: 'INGREDIENT', // TabType.BEAUTY_INGREDIENT
};
